import React from 'react'

const Twitter = props => (
  <svg height="24" viewBox="0 0 256 209" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid">
    <path d="M256 25.5a105 105 0 0 1-30.2 8.2 52.7 52.7 0 0 0 23.1-29c-10.1 6-21.4 10.4-33.3 12.7a52.5 52.5 0 0 0-89.5 48 149.1 149.1 0 0 1-108.3-55 52.3 52.3 0 0 0 16.3 70.2A52.3 52.3 0 0 1 10.3 74v.6a52.6 52.6 0 0 0 42.1 51.5 52.6 52.6 0 0 1-23.7 1c6.7 20.8 26 36 49 36.4A105.4 105.4 0 0 1 0 185.3a148.7 148.7 0 0 0 80.5 23.6c96.6 0 149.4-80 149.4-149.5l-.1-6.8A106.7 106.7 0 0 0 256 25.5"/>
  </svg>
)

export default Twitter